module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v("學習紀錄")])], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "hide-actions": "",
      "no-data-text": "目前無可用資料"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.cityAreaName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.time))])]
      }
    }]),
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0defc92c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LearningRecord.vue
// module id = 773
// module chunks = 1